export default __webpack_public_path__ + "static/ISO-45001-cad75d1b0dc736cef305c0e258a0ce7e.png";